module.exports = __webpack_public_path__ + "static/img/statusCorrect.d51dcdfb.gif";